import _ from '@lodash';
import { AppBar, Badge, DialogActions, DialogContent, IconButton, Toolbar, Tooltip, Typography } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import Constante from 'Constante.json';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { IoMdDownload } from 'react-icons/io';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as serviceWorker from 'serviceWorker';
import XAPPButton from '../Button/XAPPButton';

const md = new MobileDetect(window.navigator.userAgent);

class UpdateVersion extends XAPPComponent {

    state = {
        open: false
    }

    Atualizar = () => {
        sessionStorage.clear();
        serviceWorker.unregister();
        document.location.reload(true);
    }

    openDialog = () => {
        this.setState({ open: !this.state.open });
    }

    render() {
        const { open } = this.state;
        const { user = null } = this.props;
        var AMensagem = "versão: ";
        var Outdated = false;

        if (!_.isNull(user) && !_.isUndefined(user.settings) && !_.isNull(user.settings) && Object.keys(user.settings).length > 0 && !_.isNull(user.settings.versao)) {
            Outdated = user.settings.versao !== Constante.versao;
            AMensagem = AMensagem + user.settings.versao;
        }
        else {
            AMensagem = AMensagem + Constante.versao;
        }

        // if (document.location.host.split(".").length > 0 && document.location.host.split(".")[0] !== "app") {
        //     AMensagem = AMensagem + " - " + document.location.host.split(".")[0];
        // }

        return (
            <React.Fragment>
                <Tooltip
                    placement="top"
                    title="Versão"
                >
                    <IconButton
                        className={""}
                        onClick={() => this.openDialog()}
                        color="action"
                    >
                        <Badge
                            badgeContent={Outdated ? 1 : 0}
                            color="error"
                            className="text-4"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <IoMdDownload className="text-20 font-bold" />
                        </Badge>
                    </IconButton>
                </Tooltip>
                <XAPPDialog
                    id="UpdateVersion"
                    open={open}
                    fullWidth
                    maxWidth="sm"
                    onClose={() => this.openDialog()}
                >
                    <div className="flex w-full">
                        <div className="flex-1" />
                        <XAPPButton
                            type="Icon"
                            className=" p-6"
                            onClick={() => this.openDialog()}
                            icon={"close"}
                            iconProps="text-24"
                            color="textSecondary"
                        />
                    </div>
                    <DialogContent className="text-center">
                        {Outdated ?
                            <React.Fragment>
                                <Typography className="text-18 font-400" color="textSecondary">{"Atualização disponível"}</Typography>
                                <Typography className="text-16 font-400" color="textSecondary">{"Nova " + AMensagem}</Typography>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <Typography className="text-18 font-400" color="textSecondary">{"Você já está utilizando a versão mais atualizada"}</Typography>
                                <Typography className="text-16 font-400" color="textSecondary">{AMensagem}</Typography>
                            </React.Fragment>
                        }
                    </DialogContent>
                    {Outdated &&
                        <AppBar position="static" elevation={3} color="textSecondary">
                            <Toolbar className="flex w-full justify-end min-h-40 px-12">
                                <DialogActions>
                                    <XAPPButton
                                        type="Button"
                                        className="bg-green hover:bg-green text-white"
                                        onClick={(ev) => this.Atualizar()}
                                        variant="contained"
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"refresh"}
                                        label={"Atualizar"}
                                        key={"btnAtualizarVersao"}
                                    />
                                </DialogActions>
                            </Toolbar>
                        </AppBar>
                    }
                </XAPPDialog>
            </React.Fragment>
        )
    }
}

function mapStateToProps({ auth }) {
    return {
        user: auth.user.data,
    }
}

export default withRouter(connect(mapStateToProps)(UpdateVersion));
